import { useState } from "react";
import { Link } from "react-router-dom";
// import Logo from "../assets/Logo.svg";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const message = encodeURIComponent(
    "Hi, I'm interested in your properties listed on KL Property. Please share more details."
  );

  return (
    <header className="w-full bg-white border-b border-[#E2E8F0] sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between px-6 py-4">

        {/* Logo Section - Replaced Icon & Text with Image */}
        <Link to="/" className="flex items-center">
          {/* <img 
            src={Logo} 
            alt="KL Property Logo" 
            className="cursor-pointer h-7 md:h-16 w-32 object-fill"
          /> */}
          <h1 className="text-xl lg:text-2xl xl:text-3xl font-extrabold text-[#5aa300]">KL PROPERTY</h1>
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center gap-6 lg:gap-10 text-black font-medium">
          <Link to="/" className="hover:text-[#45A301] transition">Home</Link>
          <Link to="/properties" className="hover:text-[#45A301] transition">Properties</Link>
          <Link to="/about-us" className="hover:text-[#45A301] transition">About Us</Link>
          <Link to="/contact-us" className="hover:text-[#45A301] transition">Contact</Link>



          <button
            onClick={() =>
              window.open(`https://wa.me/918946059070?text=${message}`, "_blank")
            }
            className="bg-[#45A301] text-white px-5 py-2 rounded-md hover:bg-[#3e9202] transition-colors font-medium"
          >
            Whatsapp Now
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-2xl p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle Menu"
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {menuOpen && (
        <div className="md:hidden border-t bg-white shadow-lg animate-in slide-in-from-top duration-300">
          <nav className="flex flex-col px-6 py-6 text-black font-medium">
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
              className="py-4 border-b border-gray-50 hover:text-[#45A301]"
            >
              Home
            </Link>

            <Link
              to="/properties"
              onClick={() => setMenuOpen(false)}
              className="py-4 border-b border-gray-50 hover:text-[#45A301]"
            >
              Properties
            </Link>

            <Link
              to="/about-us"
              onClick={() => setMenuOpen(false)}
              className="py-4 border-b border-gray-50 hover:text-[#45A301]"
            >
              About Us
            </Link>

            <Link
              to="/contact-us"
              onClick={() => setMenuOpen(false)}
              className="py-4 border-b border-gray-50 hover:text-[#45A301]"
            >
              Contact
            </Link>

            {/* Mobile WhatsApp Button */}
            <button
              onClick={() => {
                setMenuOpen(false);
                window.open(`https://wa.me/918946059070?text=${message}`, "_blank");
              }}
              className="bg-[#45A301] text-white py-4 rounded-md mt-6 w-full font-bold shadow-md active:scale-95 transition"
            >
              Whatsapp Now
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}